
export const StringUtil = function () {}

// 判断字符串是否为空
StringUtil.isEmpty = function (str) {
  if (str == null || str.length === 0) {
    return true
  } else {
    return false
  }
}

// 去除对象内字符串属性的前后空格
StringUtil.trim = function (obj) {
  Object.keys(obj).forEach(function (key) {
    if (obj[key] && typeof obj[key] === 'string') {
      obj[key] = obj[key].trim()
    }
  })
  return obj
}



// WEBPACK FOOTER //
// ./src/utils/StringUtil.js